import { Client } from 'src/api/Client';
import {
  FeedsReponse,
  FeedsPayload,
  Niche,
  TrackedAccountPayload,
  TrackedAccountsResponse,
  BenRecommendationsResponse,
  AgentAccountsRecommendationsResponse,
  AgentAccountsRecommendationsPayload,
  AgentFeedsPayload,
  AgentFeedsResponse,
  SocialMediaValidationPayload,
  SocialMediaValidationResponse,
  SocialMediaSuggestionsPayload,
  SocialMediaSuggestionsResponse,
  StaticTrackedAccount,
} from './SocialMediaClient.types';

class SocialMediaClient extends Client {
  readonly route = {
    addTrackedAccount: `${this.http.baseUrl}/social-media/tracked-socials`,
    getTrackedAccounts: `${this.http.baseUrl}/social-media/tracked-socials/{brandsId}`,
    deleteTrackedAccount: `${this.http.baseUrl}/social-media/tracked-socials/account/{brandsId}/{accountId}`,
    deleteTrackedHashtag: `${this.http.baseUrl}/social-media/tracked-socials/hashtag/{brandsId}/{hashtagId}`,
    getFeeds: `${this.http.baseUrl}/social-media/feeds/{brandsId}`,
    getBrandsNiches: `${this.http.baseUrl}/brands/niches`,
    getBenRecommendations: `${this.http.baseUrl}/social-media/agent-accounts-recommendation`,
    getAgentFeeds: `${this.http.baseUrl}/social-media/agent-feeds`,
    getStaticAccounts: `${this.http.baseUrl}/social-media/agent-accounts-recommendation`,
    validateSocialMedia: `${this.http.baseUrl}/social-media/tracked-socials/account-hashtag/validate`,
    getSuggestions: `${this.http.baseUrl}/social-media/suggestions`,
  };

  addTrackedAccount = (data: TrackedAccountPayload): Promise<any> =>
    this.http.post(this.route.addTrackedAccount, data);

  getTrackedAccounts = (brandsId: string): Promise<TrackedAccountsResponse> =>
    this.http.get(this.route.getTrackedAccounts.replace('{brandsId}', brandsId));

  deleteTrackedAccount = (brandsId: string, accountId: string): Promise<any> =>
    this.http.delete(
      this.route.deleteTrackedAccount
        .replace('{brandsId}', brandsId)
        .replace('{accountId}', accountId),
    );

  deleteTrackedHashtag = (brandsId: string, hashtagId: string): Promise<any> =>
    this.http.delete(
      this.route.deleteTrackedHashtag
        .replace('{brandsId}', brandsId)
        .replace('{hashtagId}', hashtagId),
    );

  getFeeds = (data: FeedsPayload): Promise<FeedsReponse> =>
    this.http.get(this.route.getFeeds.replace('{brandsId}', data.brandId), {
      params: data.params,
    });

  getBrandsNiches = (): Promise<Niche[]> => this.http.get(this.route.getBrandsNiches);

  getBenRecommendations = (data?: AgentAccountsRecommendationsPayload): Promise<AgentAccountsRecommendationsResponse> =>
    this.http.get(this.route.getBenRecommendations, {
      params: data?.params,
    });

  getAgentFeeds = (data: AgentFeedsPayload): Promise<AgentFeedsResponse> =>
    this.http.get(this.route.getAgentFeeds, {
      params: data.params,
    });

  getStaticAccounts = (): Promise<StaticTrackedAccount[]> =>
    this.http.get(this.route.getStaticAccounts);

  validateSocialMedia = (data: SocialMediaValidationPayload): Promise<SocialMediaValidationResponse> =>
    this.http.get(this.route.validateSocialMedia, {
      params: data,
    });

  getSuggestions = (data: SocialMediaSuggestionsPayload): Promise<SocialMediaSuggestionsResponse> =>
    this.http.get(this.route.getSuggestions, {
      params: data,
    });
}

export default SocialMediaClient;
